<template>
  <svg
    class="svg-blob-one"
    width="600"
    height="600"
    viewBox="0 0 600 600"
    xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(300,300)">
      <path d="M86.6,-85.1C124.7,-91.6,176.5,-82.9,196.5,-55.7C216.5,-28.5,204.8,17.1,184.1,53.3C163.4,89.6,133.7,116.4,101.5,129.6C69.4,142.8,34.7,142.4,15.9,120.6C-2.9,98.7,-5.9,55.4,-49.6,46C-93.4,36.5,-177.9,60.9,-223.7,43.5C-269.5,26.2,-276.4,-33,-244.5,-63.5C-212.7,-94,-141.9,-96,-94.7,-86.4C-47.4,-76.9,-23.7,-56,0.3,-56.4C24.3,-56.8,48.6,-78.5,86.6,-85.1Z" fill="#FFFFFF" />
    </g>
  </svg>
</template>

<script>
export default {
  mounted() {},
  methods: {},
  computed: {},
  watch: {}
}
</script>

<style scoped>
  .svg-blob-one {
    position: absolute;
    z-index: -1;
    transform: scale(3.1);
    left: 465px;
    margin-top: -50px;
    pointer-events: none;
  }

  @media only screen and (max-width: 450px) {
    .svg-blob-one {
      transform: scale(2.1);
      left: 100px;
      margin-top: -181px;
    }
  }
</style>



// WEBPACK FOOTER //
// blob.vue?115a4d3a